export function timestampPdfFilename(): string {
  return `${Math.floor(Date.now() / 1000)}.pdf`;
}

export function saveDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = filename;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function csvCell(value: unknown): string {
  let text = String(value ?? "");
  if (/^[=+@\t\r]/.test(text) || (/^-/.test(text) && !Number.isFinite(Number(text)))) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}
